import { AppContext } from 'App.context';
import { useContext, useEffect, useState } from 'react';
import { ApiContext } from 'utils/networking/Api.context';
import constants from 'utils/constants.js';

export default function useRHConfigHook() {
  const {
    appState,
    appActions: { getSelectedHotel, translate },
  } = useContext(AppContext);
  const { API } = useContext(ApiContext);

  const [state, setState] = useState({
    isLoading: false,
    ftpHost: null,
    ftpUser: null,
    ftpPass: null,
    ftpDirPath: null,
    platform: null,
    suscription: null,
    civitfunSftpSubscription: false,
    bookingProvider: null,
    selectedOptionConnection: null,
    connectionOptions: [],
  });

  useEffect(() => {
    const fetchConfig = async () => {
      await actions.loadPoliceReportConfig();
    };
    fetchConfig();
  }, [appState.selectedHotel]);

  useEffect(() => {
    // if (!state.bookingProvider && !hasSFTPFields(state) && !state.civitfunSftpSubscription) {
    //   return;
    // }

    const options = [
      { label: translate('policeReport.sftpConfig'), value: 'SFTP' },
      // { label: translate('policeReport.apiConfig'), value: 'API' }, //TODO no available integrations for this for now
    ];

    if (state.civitfunSftpSubscription) {
      options.push({ label: translate('policeReport.s3Config'), value: 'S3' });
    }

    let selected = null;

    if (state.bookingProvider) {
      switch (state.bookingProvider) {
        case constants.BOOKING_PROVIDER.SFTP:
          selected = 'SFTP';
          break;
        case state.civitfunSftpSubscription && constants.BOOKING_PROVIDER.S3:
          selected = 'S3';
          break;
        case constants.BOOKING_PROVIDER.API:
          selected = 'API';
          break;
        default:
          selected = 'SFTP';
      }
    }

    updateState({
      connectionOptions: options,
      selectedOptionConnection: selected,
    });
  }, [state.bookingProvider, state.civitfunSftpSubscription]);

  const hasSFTPFields = currentState => {
    const sftpFields = ['ftpDirPath', 'ftpHost', 'ftpPass', 'ftpPort', 'ftpUser'];
    return sftpFields.some(field => {
      const value = currentState[field];
      return value !== null && value !== undefined && value !== '';
    });
  };

  const actions = {
    loadPoliceReportConfig: async () => {
      try {
        updateState({ isLoading: true });
        const res = await API.getBookingReportConfig({ hotelId: getSelectedHotel()?.key });
        console.log(res);
        updateState({
          isLoading: false,
          ftpHost: res?.ftpHost,
          ftpUser: res?.ftpUser,
          ftpPass: res?.ftpPass,
          ftpPort: res?.ftpPort,
          ftpDirPath: res?.ftpDirPath,
          platform: res?.platform,
          suscription: res?.suscription === 'active',
          civitfunSftpSubscription: res?.civitfunSftpSubscription === 'active',
          bookingProvider: res?.bookingProvider,
        });
      } catch (err) {
        console.warn(err);
        updateState({ isLoading: false });
      }
    },
    handleSelectConnection: async option => {
      updateState({ selectedOptionConnection: option });
    },
    requestGuestlinkFunctionality: () => {
      updateState({ isLoading: true });
      API.requestFunctionalityContract({
        hotelId: getSelectedHotel().key,
        suscription: 'bookings_report',
        functionality: 'Police Report Module',
      })
        .then(_ => {
          actions.sendRequestPoliceFunctionalityEmail();
        })
        .catch(_ => {
          updateState({ isLoading: false });
        });
    },
  };

  function updateState(object) {
    setState(previousState => ({ ...previousState, ...object }));
  }

  return { state, actions };
}
